var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import State from "../Screens/Screens";
import axios from "axios";
import { apiUrl } from "../Utils/index";
import { Network } from "./Network";
import { AssetsController } from "./AssetsController";
export class GameController {
    constructor(app) {
        // scene management
        this.state = 0;
        this.deltaCamY = 2.7; // offset for camera to prevent camera moving when the player rotates
        this.isMobile = false;
        this.currentChats = [];
        this._loadedAssets = [];
        this.instances = new Map();
        this.materials = new Map();
        //
        this.sellingMode = false;
        // all game data
        this._gameData = {
            items: [],
            abilities: [],
            locations: [],
            races: [],
            quests: [],
            help: [],
        };
        // core
        this.engine = app.engine;
        this.config = app.config;
        this.scene = app.scene;
        // create colyseus client
        this.client = new Network(app.config.port);
        // check if on mobile
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.isMobile = true;
        }
    }
    setErrorCode(message) {
        console.error(message);
        this.latestError = message;
    }
    /////////////////////////////////////////
    //////////// SCENE MANAGEMENT ///////////
    /////////////////////////////////////////
    setScene(newState) {
        this.nextScene = newState;
    }
    /////////////////////////////////////////
    //////////// GAME DATA /////////////////
    /////////////////////////////////////////
    initializeGameData() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield axios.request({
                method: "GET",
                url: apiUrl(this.config.port) + "/load_game_data",
            });
            this._gameData = result.data.data;
            console.log("[GAME] loaded game data", this._gameData);
        });
    }
    getGameData(type, key) {
        var _a, _b, _c, _d, _e;
        let returnData;
        switch (type) {
            case "ability":
                returnData = (_a = this._gameData.abilities[key]) !== null && _a !== void 0 ? _a : false;
                break;
            case "race":
                returnData = (_b = this._gameData.races[key]) !== null && _b !== void 0 ? _b : false;
                break;
            case "location":
                returnData = (_c = this._gameData.locations[key]) !== null && _c !== void 0 ? _c : false;
                break;
            case "item":
                returnData = (_d = this._gameData.items[key]) !== null && _d !== void 0 ? _d : false;
                break;
            case "quest":
                returnData = (_e = this._gameData.quests[key]) !== null && _e !== void 0 ? _e : false;
                break;
            case "":
                returnData = false;
                break;
        }
        return returnData;
    }
    loadGameData(type) {
        var _a, _b, _c, _d, _e, _f;
        let returnData;
        switch (type) {
            case "abilities":
                returnData = (_a = this._gameData.abilities) !== null && _a !== void 0 ? _a : false;
                break;
            case "races":
                returnData = (_b = this._gameData.races) !== null && _b !== void 0 ? _b : false;
                break;
            case "locations":
                returnData = (_c = this._gameData.locations) !== null && _c !== void 0 ? _c : false;
                break;
            case "items":
                returnData = (_d = this._gameData.items) !== null && _d !== void 0 ? _d : false;
                break;
            case "quests":
                returnData = (_e = this._gameData.quests) !== null && _e !== void 0 ? _e : false;
                break;
            case "help":
                returnData = (_f = this._gameData.help) !== null && _f !== void 0 ? _f : false;
                break;
            case "":
                returnData = false;
                break;
        }
        return returnData;
    }
    /////////////////////////////////////////
    //////////// ASSETS DATA /////////////////
    /////////////////////////////////////////
    fetchAsset(key) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._loadedAssets[key]) {
                return this._loadedAssets[key];
            }
        });
    }
    initializeAssetController() {
        return __awaiter(this, arguments, void 0, function* (shadow = null) {
            this._loadedAssets = [];
            this._assetsCtrl = new AssetsController(this, shadow);
        });
    }
    /////////////////////////////////////////
    //////////// AUTH DATA /////////////////
    /////////////////////////////////////////
    get currentUser() {
        return this._currentUser;
    }
    get currentCharacter() {
        return this._currentCharacter;
    }
    // check login details
    forceLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            const req = yield axios.request({
                method: "POST",
                url: apiUrl(this.config.port) + "/returnRandomUser",
            });
            let character = req.data.user;
            if (character) {
                // set user
                this.setUser({
                    id: character.user_id,
                    username: character.username,
                    password: character.password,
                    token: character.token,
                });
                //set character
                this.setCharacter(character);
            }
        });
    }
    isLoggedIn() {
        return this._currentUser ? true : false;
    }
    // check login details
    isValidLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            let user = this.currentUser;
            // check user exists else send back to login
            const req = yield axios.request({
                method: "POST",
                params: { token: user.token },
                url: apiUrl(this.config.port) + "/check",
            });
            // check req status
            if (req.status === 200) {
                let user = req.data.user;
                this.setUser(user);
                return user;
            }
            else {
                // something went wrong
                console.error("Something went wrong.");
            }
        });
    }
    // login as this character
    login(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            // make sure both the username and password is entered.
            if (!username || !password) {
                console.error("Please enter both the username and the password.");
                return false;
            }
            // send login data
            const req = yield axios.request({
                method: "POST",
                params: {
                    username: username,
                    password: password,
                },
                url: apiUrl(this.config.port) + "/login",
            });
            // check req status
            if (req.status === 200) {
                // user was found or created
                this._currentUser = req.data.user;
                // save token to local storage
                localStorage.setItem("t5c_token", req.data.user.token);
                // go to character selection page
                return true;
            }
            else {
                // something went wrong
                console.error("Something went wrong.");
                return false;
            }
        });
    }
    // set user
    setUser(user) {
        this._currentUser = user;
    }
    // set character
    setCharacter(character) {
        this._currentCharacter = character;
        this.currentLocationKey = character.location;
        this.currentLocation = this.getGameData("location", character.location);
    }
    // set character
    setLocation(location) {
        this.currentLocationKey = location;
        this.currentLocation = this.getGameData("location", location);
        this._currentCharacter.location = location;
    }
    // logout
    logout() {
        this._currentUser = null;
        this._currentCharacter = null;
        this.setScene(State.LOGIN);
    }
    sendMessage(type, data = {}) {
        let message = {
            date: new Date().getTime(),
        };
        if (Object.keys(data).length) {
            for (const [key, value] of Object.entries(data)) {
                message[key] = value;
            }
        }
        this.currentRoom.send(type, message);
    }
}
